import { render, staticRenderFns } from "./Commission_ItemEdit.vue?vue&type=template&id=fc36acd6&scoped=true&"
import script from "./Commission_ItemEdit.vue?vue&type=script&lang=js&"
export * from "./Commission_ItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./Commission_ItemEdit.vue?vue&type=style&index=0&id=fc36acd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc36acd6",
  null
  
)

export default component.exports